<template>
  <TwTableFilterBar
    :filterModel="filterForm"
    :filterChips="filterChips"
    @apply="applyFilter"
  >
    <template #form="{ model }">

      <!-- 更新日時 -->
      <el-form-item label="更新日時">
        <el-date-picker
            v-model="model.dateRange"
            type="daterange"
            range-separator="〜"
            start-placeholder="開始日"
            end-placeholder="終了日"
            format="yyyy/MM/dd"
            value-format="yyyy-MM-dd"
            style="width: 100%;"
          />
      </el-form-item>

      <!-- ステータス -->
      <el-form-item label="ステータス">
        <el-select v-model="model.status" placeholder="選択してください">
          <el-option label="未対応" value="pending" />
          <el-option label="対応中" value="in_progress" />
          <el-option label="完了" value="done" />
        </el-select>
      </el-form-item>

      <!-- 取引名 -->
      <el-form-item label="取引名">
        <el-input v-model="model.owner" placeholder="例：〇〇商事" />
      </el-form-item>

      <!-- オーナー -->
      <el-form-item label="オーナー">
        <el-select v-model="model.ownerId" placeholder="オーナーを選択">
          <el-option
                v-for="user in ownerOptions"
                :key="user.id"
                :label="user.name"
                :value="user.id"
              />
        </el-select>
      </el-form-item>

      <!-- 取引ID -->
      <el-form-item label="取引ID">
        <el-input v-model="model.tradeId" placeholder="TRD12345など" />
      </el-form-item>

    </template>
  </TwTableFilterBar>
</template>
<script>

import {
  defineComponent,
  reactive,
  computed,
} from '@vue/composition-api';
import dayjs from 'dayjs';

import TwTableFilterBar from '@/components/vue3/TwTableFilterBar.vue';

export default defineComponent({
  name: 'TradingListFilter',
  components: {
    TwTableFilterBar,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['input', 'apply'],
  setup(props, { emit }) {
    const filterForm = reactive({
      status: '',
      dateRange: [
        dayjs()
          .subtract(180, 'day')
          .toDate(),
        dayjs().toDate(),
      ],
      owner: '',
      ownerId: '',
      tradeId: '',
    });
    const ownerOptions = [
      { id: '1', name: '山田 太郎' },
      { id: '2', name: '佐藤 花子' },
      { id: '3', name: '田中 一郎' },
    ];

    const filterChips = computed(() => {
      const chips = [];
      if (filterForm.status)
        chips.push({
          label: 'ステータス',
          value: filterForm.status,
          key: 'status',
        });
      if (filterForm.dateRange?.length === 2)
        chips.push({
          label: '更新日時',
          value: `${dayjs(filterForm.dateRange[0]).format(
            'YYYY/MM/DD',
          )} - ${dayjs(filterForm.dateRange[1]).format('YYYY/MM/DD')}`,
          key: 'dateRange',
        });
      if (filterForm.owner)
        chips.push({ label: '取引名', value: filterForm.owner, key: 'owner' });
      if (filterForm.ownerId) {
        const owner = ownerOptions.find(o => o.id === filterForm.ownerId);
        chips.push({
          label: 'オーナー',
          value: owner?.name || filterForm.ownerId,
          key: 'ownerId',
        });
      }
      if (filterForm.tradeId)
        chips.push({
          label: '取引ID',
          value: filterForm.tradeId,
          key: 'tradeId',
        });
      return chips;
    });
    const applyFilter = () => {
      emit('apply', { ...filterForm });
    };
    const resetFilter = () => {
      internalFilters.dateRange = [null, null];
      internalFilters.tradingId = '';
      internalFilters.owner = '';
      internalFilters.ownerSection = null;
      internalFilters.draft = null;
    };
    return {
      ownerOptions,
      filterForm,
      filterChips,
      applyFilter,
      resetFilter,
    };
  },
});
</script>
<style scoped>
.trading-list-filter {
  padding: 12px;
}
.footer {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
</style>
